import React from 'react';
import styles from '../view.module.css';

const TagList = ({ values }) => (
  <div className={styles.tags}>
    {values.map((v) => (
      <span key={v} className={styles.tag}>
        {v}
      </span>
    ))}
  </div>
);

export default TagList;
